// extracted by mini-css-extract-plugin
module.exports = {"item":"item--cNX8v","text":"text--2f0X_","icon":"icon--25YUr","selected":"selected--3wMER"};